<template>
  <v-container fluid class="container--style">
    <div>
      <v-snackbar class="new-alert" v-model="alert" :timeout="timeout" :color="alertType" top="top">
        {{this.alertMessage}}
        <v-icon color="white" flat @click="alert = false">close</v-icon>
      </v-snackbar>
    </div>
    <v-layout>
      <v-flex md12 lg12 xs12 sm12 xl12>
        <h2>Estado de aprobación</h2>
        <v-card class="comentario" dark>
          <v-card-title class="color">
            <v-layout>
              <v-chip>
                <v-avatar>
                  <v-icon dark>account_circle</v-icon>
                </v-avatar>Observacion DCA
              </v-chip>
            </v-layout>
            <v-layout justify-end>
              <span>{{date}}</span>
            </v-layout>
          </v-card-title>
          <v-layout align-center>
            <v-flex md12 lg12 xs12 sm12 xl12>
              <v-layout>
                <v-card-text class="fontSize" v-if="estado">Estado: DCA ha escrito un comentario para esta etapa</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text
                  class="fontSize"
                  v-if="!estado"
                >Estado: La información aún no ha sido proporcionada por DCA</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text class="fontSize">Observación: {{obsEtapa}}</v-card-text>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      date:"",
      nEtapa: "",
      estadoVipo: "",
      obsEtapaVipo: "",
      estadoPro: "",
      obsEtapaPro: "",
      estado: "",
      etapa: "",
      obsEtapa: "",
      alertType: "",
      alertMessage: "",
      alert: false,
      timeout: 4000,
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.verificaPath();
    }
  },

  created() {
    this.verificaPath();
  },

  methods: {
    verificaPath() {

      if (this.$route.params.id >0 && this.$route.params.id <8)
        this.nEtapa = parseInt(this.$route.params.id) + 1;
      this.getEtapa();
      console.log(this.nEtapa)
    },
    getEtapa() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/getEtapa",
          this.auth
        )
        .then(response => {
          //console.log("ESTADO");
          //console.log(this.nEtapa);
          //console.log(response.data);
          //console.log(response.data["comentarioEtapa" + this.nEtapa]);
          this.etapa = response.data;
          console.log(response.data)
          this.obsEtapa = response.data["comentario" + this.nEtapa];
          this.estado = this.etapa["check" + this.nEtapa];
          this.date = this.etapa["fecha" + this.nEtapa];

          //console.log(this.obsEtapa);
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    }
  }
};
</script>

<style scoped>
.new-alert {
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.v-card {
  padding-right: 0% !important;
  padding-left: 0% !important;
  padding-top: 0% !important;
}

.v-card__title.color {
  background: #eb7704;
  font-size: 14px;
  padding: 5px;
}

.v-card__text {
  background-color: #4376a2;
  padding: 1%;
  text-align: justify;
}
.comentario {
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 2%;
  margin-bottom: 2%;
}

.container--style {
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.fontSize {
  font-size: 20px !important;
}

.carousel {
  height: 650px !important;
  width: 650px !important;
  margin: 1% auto 1% auto !important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.image {
  cursor: pointer;
}

.color{
  background-color: #1c345d !important;
} 
</style>




// WEBPACK FOOTER //
// src/components/dca/documentosPost/Comentario.vue